module.exports = __webpack_public_path__ + "img/map.4395e613.png";